export default __webpack_public_path__ + "static/media/next.0d9fccfe.svg";